import { queryOptions, skipToken, useQuery } from '@tanstack/react-query'

import { intentionApi } from '../api/intentionApi'

const getIntentionThemeQueryOptions = (slug?: string) =>
  queryOptions({
    queryKey: ['intention_theme', slug],
    queryFn: slug != null ? ({ signal }) => intentionApi.getIntentionTheme(slug, { signal }) : skipToken,
    enabled: slug != null,
  })

export const useIntentionThemeQuery = (slug?: string) => useQuery(getIntentionThemeQueryOptions(slug))
